import * as types from '../types/marketing'
import createReducer from '../createReducer'
import _clonedeep from 'lodash.clonedeep'

import { MARKETING } from '../../constants'

const initialState = {
  campaigns: [],
  campaign: {
    createdBy: '',
    company: '',
    id: null,
    name: '',
    startDate: '',
    endDate: '',
    duration: 1,
    durationLabel: 'days',
    cost: 0,
    costCurrency: 'EUR',
    externalId: '',
    occasionName: '',
    occasionId: '',
    filterTickets: {},
    excelUsers: [],
    channels: [],
    usersByChannel: [],
    totalUsers: 0,
    launchDate: '',
    templates: [],
    facebookCampaign: {},
    advancedFilters: {
      type: 'all',
      filters: [],
    },
    typeFilterUsed: 'none',
    canOverwriteName: false
  },
  excelData: {},
  // filters: {},
  advancedFilters: {
    type: '',
    filters: [],
  },
  recipients: [],
  templates: {
    facebook: [],
    whatsapp: [],
    whatsapp_whatsapp: [],
    sms: [],
    telegram: [],
    chatmail: [],
    chatweb: [],
    android: [],
    ios: [],
    instagram: [],
    company: {},
    variables: [],
  },
  // Filters
  colsToShow: ['name', 'createdAt', 'startDate', 'endDate', 'state', 'createdByName', 'durationTime'],
  limit: 30,
  page: 0,
  textToSearch: '',
  name: '',
  startDate: ['', ''],
  endDate: ['', ''],
  campaignDate: ['', ''],
  duration: '',
  cost: '',
  createdAt: ['', ''],
  isActive: '',
  state: 'all',
  channels: [],
  brands: [],
  delegations: [],
  company: '',
  totalCampaigns: 0,
  campaignDetail: {},
  channelsInFilters: [],
  operators: [],
  states: [],
  checked: [],
  sortByField: 'createdAt',
  sortType: 'desc'
}

export default createReducer(initialState, {
  [types.SET_EXCEL_DATA](state, action) {
    return { ...state, excelData: action.excelData }
  },
  [types.SET_CAMPAIGN_DATA](state, action) {
    return _clonedeep({ ...state, campaign: action.campaign })
  },
  [types.REINITIALIZE_CAMPAIGN_DATA](state, action) {
    return { ...state, campaign: initialState.campaign, excelData: initialState.excelData }
  },
  [types.UPDATE_EXCEL_USERS](state, action) {
    return { ...state, campaign: { ...state.campaign, excelUsers: action.excelUsers } }
  },
  [types.UPDATE_OVERWRITE_NAME](state, action) {
    return { ...state, campaign: { ...state.campaign, canOverwriteName: action.canOverwriteName } }
  },
  [types.UPDATE_FILTERS](state, action) {
    const { filters } = action
    /* const newFilters = {
                 ...state.filters,
                 ...filters,
             }*/
    const newCampaignFilters = {
      ...state.campaign.filterTickets,
      ...filters,
    }
    return _clonedeep({
      ...state,
      //filters: newFilters,
      campaign: { ...state.campaign, filterTickets: newCampaignFilters },
    })
  },
  [types.UPDATE_ADVANCED_FILTERS](state, action) {
    return _clonedeep({
      ...state,
      advancedFilters: action.advancedFilters,
      campaign: { ...state.campaign, advancedFilters: action.advancedFilters },
    })
  },
  [types.MARKETING_GET_ALL_TEMPLATES_REQUEST](state) {
    return { ...state }
  },
  [types.MARKETING_GET_ALL_TEMPLATES_SUCCESS](state, { data: { templates } }) {
    return {
      ...state,
      templates: {
        ...state.templates,
        facebook: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.facebook),
        instagram: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.instagram),
        whatsapp: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.whatsapp && t.provider.toLowerCase() !== MARKETING.channels.whatsapp),
        whatsapp_whatsapp: templates.filter((t) => t.provider.toLowerCase() === MARKETING.channels.whatsapp),
        sms: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.sms),
        telegram: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.telegram),
        chatmail: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.chatmail),
        chatweb: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.chatweb),
        android: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.android),
        ios: templates.filter((t) => t.channel.toLowerCase() === MARKETING.channels.ios)
      },
    }
  },
  [types.MARKETING_CREATE_TEMPLATE_REQUEST](state) {
    return { ...state }
  },
  [types.MARKETING_CREATE_TEMPLATE_SUCCESS](state, { data: { template } }) {
    const channel = template.channel.toLowerCase()
    return {
      ...state,
      templates: {
        ...state.templates,
        [channel]: [...state.templates[channel], template],
      },
    }
  },
  [types.MARKETING_UPDATE_TEMPLATE_REQUEST](state) {
    return { ...state }
  },
  [types.MARKETING_UPDATE_TEMPLATE_SUCCESS](state, { data: { template } }) {
    const channel = template.channel.toLowerCase()
    const index = state.templates[channel].findIndex((t) => t._id === template._id)
    state.templates[channel][index] = template
    return {
      ...state,
      templates: {
        ...state.templates,
        [channel]: [...state.templates[channel]],
      },
    }
  },
  [types.MARKETING_PUBLISH_TEMPLATE_REQUEST](state) {
    return { ...state }
  },
  [types.MARKETING_PUBLISH_TEMPLATE_SUCCESS](state) {
    return { ...state }
  },
  [types.MARKETING_DELETE_TEMPLATE_REQUEST](state) {
    return { ...state }
  },
  [types.MARKETING_DELETE_TEMPLATE_SUCCESS](state) {
    return { ...state }
  },
  [types.MARKETING_GET_TEMPLATE_VARIABLES_REQUEST](state) {
    return { ...state }
  },
  [types.MARKETING_GET_TEMPLATE_VARIABLES_SUCCESS](state, { data }) {
    return {
      ...state,
      templates: {
        ...state.templates,
        company: data.company,
        variables: data.templateVars,
      },
    }
  },
  [types.MARKETING_GET_CAMPAIGNS](state, { data }) {
    return {
      ...state,
      campaigns: data.results,
      totalCampaigns: data.totalCampaigns,
    }
  },
  [types.MARKETING_CAMPAIGNS_UPDATE_FILTERS](state, { field, value }) {
    return { ...state, [field]: value }
  },
  [types.MARKETING_GET_CAMPAIGN](state, { data }) {
    return {
      ...state,
      campaignDetail: data.result,
    }
  },
  [types.UPDATE_CHANNEL](state, { channels }) {
    return { ...state, campaign: { ...state.campaign, channels: channels } }
  },
})
